// extracted by mini-css-extract-plugin
export default {"copilotCard":"CopilotCodingAgentStatus-module__copilotCard--ILAZm","arrowBoth":"CopilotCodingAgentStatus-module__arrowBoth--d8Jfk"};